import './PushTokenSyncLoading.scss';
import React, { useEffect, useState } from 'react';
import { IonIcon, IonSpinner, IonText } from '@ionic/react';
import clsx from 'clsx';
import { checkmarkOutline } from 'ionicons/icons';
import { useTracked } from '../../state';

const PushTokenSyncLoading: React.FC = () => {
  const [state] = useTracked();
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   dispatch({
  //     type: 'setPushTokenSyncLoading',
  //     pushTokenSyncLoading: true,
  //   });

  //   setTimeout(() => {
  //     dispatch({
  //       type: 'setPushTokenSyncLoading',
  //       pushTokenSyncLoading: false,
  //     });
  //   }, 5000)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (state.pushTokenSyncLoading) {
      setTimeout(() => {
        setIsLoading(true);
      }, 2000);
    } else {
      if (isLoading) {
        setTimeout(() => {
          setIsLoading(false);
        }, 3000);
      }
    }
  }, [state.pushTokenSyncLoading, isLoading]);

  return (
    <React.Fragment>
      <div
        className={clsx("push-token-sync-loading-container bordered", {
          'is-synching': isLoading,
        })}>
        <div className="loading-text">
          <IonText>
            {state.pushTokenSyncLoading ? 'Push token sync in progress' : 'Push token sync complete'}</IonText>
        </div>
        <div className="loading-spinner">
          {state.pushTokenSyncLoading && <IonSpinner />}
          {!state.pushTokenSyncLoading && <IonIcon color="success" icon={checkmarkOutline} />}
        </div>
      </div>
    </React.Fragment>
  )
}

export default PushTokenSyncLoading;